"use client"

import { useMediaQuery } from "@mui/material"

export default function useTouchable(): boolean {
    return useMediaQuery('@media (pointer: coarse)')
}